import { render, staticRenderFns } from "./SegmentNew.vue?vue&type=template&id=3faa9bfc&scoped=true&"
import script from "./SegmentNew.vue?vue&type=script&lang=js&"
export * from "./SegmentNew.vue?vue&type=script&lang=js&"
import style0 from "./SegmentNew.vue?vue&type=style&index=0&id=3faa9bfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faa9bfc",
  null
  
)

export default component.exports